var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apexchart',{staticClass:"card-rounded-bottom",attrs:{"options":_vm.chartOptions,"series":_vm.series,"type":"pie","width":"100%","height":"390"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }